import { render, staticRenderFns } from "./labelStat.vue?vue&type=template&id=336dad15&scoped=true&"
import script from "./labelStat.vue?vue&type=script&lang=js&"
export * from "./labelStat.vue?vue&type=script&lang=js&"
import style0 from "./labelStat.vue?vue&type=style&index=0&id=336dad15&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336dad15",
  null
  
)

component.options.__file = "labelStat.vue"
export default component.exports